module.exports = __webpack_public_path__ + "img/cjdds.3decfa24.png";